import { TeamReviewApprovalSetting } from './TeamReviewApprovalSetting';
import { TeamReviewMemberOrderSetting } from './TeamReviewMemberOrderSetting';
import { TeamReviewMemberOrder } from './TeamReviewMemberOrder';
import { TeamReviewSettings } from './TeamReviewSettings';

// Mirrors backend C# record TeamReviewOrderDto
export interface TeamReviewOrderDto {
  teamReviewSettingsId: string;
  teamMemberId: string;
  position: number;
  firstName?: string;
  lastName?: string;
}

// Mirrors backend C# record TeamReviewSettingsDto
export interface TeamReviewSettingsDto {
  teamReviewSettingsId: string;
  teamId: string;
  teamReviewSetting: TeamReviewApprovalSetting; // (C# TeamReviewSetting)
  teamReviewMemberOrder: TeamReviewMemberOrderSetting; // (C# TeamReviewMemberOrder)
  teamOrder: TeamReviewOrderDto[]; // (C# TeamOrder)
}

// Build a DTO from the domain model
export function toTeamReviewSettingsDto(model: TeamReviewSettings): TeamReviewSettingsDto {
  return {
    teamReviewSettingsId: model.teamReviewSettingsId,
    teamId: model.teamId,
    teamReviewSetting: model.teamReviewApprovalSetting,
    teamReviewMemberOrder: model.teamReviewMemberOrderSetting,
    teamOrder: (model.teamMemberOrder || []).map(m => ({
      teamReviewSettingsId: m.teamReviewSettingsId,
      teamMemberId: m.teamMemberId,
      position: m.position,
      firstName: m.firstName,
      lastName: m.lastName,
    }))
  };
}

// Build a domain model from a DTO
export function fromTeamReviewSettingsDto(dto: TeamReviewSettingsDto): TeamReviewSettings {
  const model = new TeamReviewSettings();
  model.teamReviewSettingsId = dto.teamReviewSettingsId;
  model.teamId = dto.teamId;
  model.teamReviewApprovalSetting = dto.teamReviewSetting;
  model.teamReviewMemberOrderSetting = dto.teamReviewMemberOrder;
  model.teamMemberOrder = (dto.teamOrder || []).map(o => {
    const order = new TeamReviewMemberOrder();
    order.teamReviewSettingsId = o.teamReviewSettingsId;
    order.teamMemberId = o.teamMemberId;
    order.position = o.position;
    order.firstName = o.firstName || '';
    order.lastName = o.lastName || '';
    return order;
  });
  return model;
}

// Helper for creating a default DTO directly from teammates when settings are absent
export function buildDefaultTeamReviewSettingsDto(teamId: string, teammates: Array<{ id: string; firstName: string; lastName: string }>): TeamReviewSettingsDto {
  return {
    teamReviewSettingsId: '',
    teamId,
    teamReviewSetting: TeamReviewApprovalSetting.AllPass,
    teamReviewMemberOrder: TeamReviewMemberOrderSetting.Any,
    teamOrder: teammates.map((m, idx) => ({
      teamReviewSettingsId: '',
      teamMemberId: m.id,
      position: idx,
      firstName: m.firstName,
      lastName: m.lastName,
    }))
  };
}
